import { Component, ViewEncapsulation } from '@angular/core';

/**
 * It is used to provide gloabal scope styles
 * It is create with ui module being loaded
 */
@Component({
    standalone: false,
    template: '',
    styleUrls: ['./icms-client-global-styles.scss'],
    encapsulation: ViewEncapsulation.None,
    selector: 'icms-client-global-styles'
})
export class ICmsClientGlobalStylesComponent {}
